
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pupils/years",
      function () {
        return require("private-next-pages/pupils/years.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pupils/years"])
      });
    }
  